import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

export const InputIcon = styled.img.attrs({
  src: props =>
    props.show
      ? "/assets/images/icon-chevron-up.svg"
      : "/assets/images/icon-chevron-down.svg"
})`
  cursor: pointer;
  outline: none;
  position: absolute;
  right: 10px;
  top: 46px;
`;

export const List = styled.ul`
  background: ${props => props.theme.colors.white};
  border: ${props => `1px solid ${props.theme.colors.silver}`};
  border-radius: 2px;
  box-shadow: 0 0 20px 0 rgba(109, 120, 129, 0.16);
  display: ${props => (props.show ? "initial" : "none")};
  left: 0;
  max-height: 35vh;
  outline: none;
  overflow-x: auto;
  position: absolute;
  right: 0;
  top: 79px;
  z-index: 3;
`;

export const TextHightlight = styled.span`
  background-color: #e5eef6;
`;

export const ListItem = styled.li`
  align-items: center;
  background: ${p => (p.active ? "#eee" : "initial")};
  border-bottom: ${p => `1px solid ${p.theme.colors.silver}`};
  cursor: pointer;
  display: flex;
  height: 52px;
  outline: none;
  padding: 0 0 0 15px;
  white-space: pre-wrap;

  &:hover {
    background: ${p => p.theme.colors.alabaster};
    color: ${p => p.theme.colors.solera};
  }

  ${p =>
    p.highlight &&
    `
    & > ${TextHightlight} {
      background-color: #dee6ee;
    }
  `};
`;

export const Required = styled.span`
  color: ${p => p.theme.colors.solera};
  /* font-size: 12px; */
  &::after {
    content: " *";
    opacity: ${props => (props.required ? 1 : 0)};
    white-space: pre;
  }
`;

const getBorder = props => {
  const {
    theme: { colors }
  } = props;

  let color = colors.iron;
  if (props.error) color = colors.monza;
  if (props.focus) color = colors.solera;

  return `1px solid ${color}`;
};
export const InputWrapper = styled.div`
  align-items: center;
  background: ${p =>
    p.disabled
      ? p.theme.colors.silver
      : p.error
        ? p.theme.colors.monzaLightest
        : "initial"};
  border: ${getBorder};
  display: flex;
  height: 52px;
  margin: 5px 0 24px 0;
  outline: none;
  padding: 0 25px 0 0;
  width: 100%;
`;

export const Input = styled.input`
  background-color: transparent;
  border: none;
  flex: 1 0 1px;
  height: 100%;
  outline: none;
  padding: 0 0 0 16px;
`;

export const Label = styled.label`
  flex: 0 0 320px;
  line-height: 20px;
  min-width: 320px;
  position: relative;
  text-align: left;
`;
